import GerepAPI from './GerepAPI'

export default class ArticleService {
	static getArticles(token) {
		return GerepAPI.get('/articles/doubleAuthent', null, token)
	}

	static getArticle(token, shortcut) {
		return GerepAPI.get('/articles/networkPartner', { shortcut }, token)
	}
}
